import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { LanguageProvider } from './useLanguage';
import ModernHome from './pages/ModernHome';
import WorkshopsPage from './pages/WorkshopsPage';
import GamesPage from './pages/GamesPage';
import PrivacyPage from './pages/PrivacyPage';
import ErrorPage from './pages/ErrorPage';

function App() {
  const router = createBrowserRouter([
    {
      path: '/',
      element: <ModernHome />,
      errorElement: <ErrorPage />
    },
    {
      path: '/workshops',
      element: <WorkshopsPage />,
      errorElement: <ErrorPage />
    },
    {
      path: '/games',
      element: <GamesPage />,
      errorElement: <ErrorPage />
    },
    {
      path: '/privacy',
      element: <PrivacyPage />,
      errorElement: <ErrorPage />
    },
  ]);

  return (
    <LanguageProvider>
      <ThemeProvider>
        <div className="App">
          <RouterProvider router={router} />
        </div>
      </ThemeProvider>
    </LanguageProvider>
  );
}

export default App;
